var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "membership" },
    [
      _c(
        "div",
        {
          staticClass: "log-in-bar clearfix",
          class: { "modal-mode": _vm.modalMode },
        },
        [
          _vm.modalMode
            ? _c(
                "a",
                {
                  staticClass: "close-btn pull-right",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.onClose($event)
                    },
                  },
                },
                [_c("i", { staticClass: "ion-ios-close-empty" })]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loggedIn && !_vm.user
            ? _c("div", { staticClass: "login-link pull-right" }, [
                _c("span", { staticClass: "text" }, [
                  _vm._v("Already a member?"),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "pull-right",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.showLogin = true
                      },
                    },
                  },
                  [_vm._v("\n        Log in\n      ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loggedIn && _vm.user && _vm.mounted
            ? _c(
                "dropdown",
                {
                  staticClass: "dropdown profile clearfix pull-right",
                  attrs: { "close-on-click-el": _vm.$el },
                },
                [
                  _c(
                    "template",
                    { attrs: { slot: "toggle" }, slot: "toggle" },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("img", {
                          staticClass: "profile-pic pull-left",
                          attrs: { src: _vm.user.imageUrl },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "name pull-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.user.name) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "icon ion-ios-arrow-down" }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("template", { attrs: { slot: "menu" }, slot: "menu" }, [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "dropdown-menu dropdown-menu-with-arrows pull-right",
                      },
                      [
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.logout($event)
                                },
                              },
                            },
                            [_vm._v("\n              Logout\n            ")]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLogin
        ? _c(
            "div",
            { staticClass: "membership-login" },
            [
              _c("div", { staticClass: "back-btn" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.showLogin = false
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "icon ion-ios-arrow-back" }),
                    _vm._v(" Back\n      "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("login"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.showLogin ? _c("router-view") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/Membership/template.html?vue&type=template&id=e5451dee&
// module id = 1060
// module chunks = 0